import { atom } from "jotai";

export const hostsAtom = atom<
  Partial<Record<"api" | "ngApi" | "clients" | "data" | "webSocket", string>>
>({});
